import { render } from "./SingleTtrCard.vue?vue&type=template&id=23bb4a5b&scoped=true"
import script from "./SingleTtrCard.vue?vue&type=script&lang=js"
export * from "./SingleTtrCard.vue?vue&type=script&lang=js"

import "./SingleTtrCard.vue?vue&type=style&index=0&id=23bb4a5b&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bb4a5b"]])

export default __exports__